(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editable-home-07"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('melo-film-player')) {
    customElements.define('melo-film-player', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.preview = this.querySelector('.melo-film__preview');
        this.full = this.querySelector('.melo-film__full');
        this.watch = this.querySelector('.melo-film__watch');
        this.pauseButton = this.querySelector('.melo-film__pause');
        this.error = this.querySelector('.melo-film__error');
        this.fullMode = false;
        this.userPaused = false;
        this.inView = false;
        this.preview.muted = true;
        this.preview.hidden = false;
        this.full.hidden = true;
        this.watch.textContent = this.dataset.watchLabel;
        this.watch.setAttribute('aria-expanded', 'false');
        this.pauseButton.hidden = false;
        this.pauseButton.textContent = this.dataset.pauseLabel;
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        this.source = (mobile && this.dataset.mobileSrc) || this.dataset.desktopSrc;
        this.watch.disabled = !this.source;
        this.pauseButton.disabled = !this.source;
        if (!this.source) this.error.hidden = false;

        const previewStart = () => {
          const start = Math.max(0, Number(this.dataset.previewStart) || 0);
          return Number.isFinite(this.preview.duration) ? Math.min(start, Math.max(0, this.preview.duration - 0.25)) : start;
        };
        this.preview.addEventListener('loadedmetadata', () => {
          this.preview.currentTime = previewStart();
        }, options);
        this.preview.addEventListener('timeupdate', () => {
          if (this.fullMode) return;
          if (!Number.isFinite(this.preview.duration)) return;
          const start = previewStart();
          const seconds = Number(this.dataset.previewSeconds) || 8;
          const end = Math.min(start + seconds, this.preview.duration);
          if (this.preview.currentTime < start || this.preview.currentTime >= end) this.preview.currentTime = start;
        }, options);
        this.watch.addEventListener('click', () => {
          this.error.hidden = true;
          if (this.fullMode) {
            this.fullMode = false;
            this.full.pause();
            this.full.hidden = true;
            this.preview.hidden = false;
            this.preview.currentTime = previewStart();
            this.userPaused = false;
            this.watch.textContent = this.dataset.watchLabel;
            this.watch.setAttribute('aria-expanded', 'false');
            this.pauseButton.hidden = false;
            this.pauseButton.textContent = this.dataset.pauseLabel;
            this.updatePreview();
            return;
          }
          this.fullMode = true;
          this.preview.pause();
          this.preview.hidden = true;
          this.full.hidden = false;
          this.full.controls = true;
          this.full.loop = false;
          this.full.muted = false;
          if (!this.full.getAttribute('src')) this.full.src = this.source;
          this.full.currentTime = 0;
          this.watch.textContent = this.dataset.returnLabel;
          this.watch.setAttribute('aria-expanded', 'true');
          this.pauseButton.hidden = true;
          this.full.play().catch(() => {});
        }, options);
        this.pauseButton.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.pauseButton.textContent = this.userPaused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
          this.updatePreview();
        }, options);
        [this.preview, this.full].forEach(video => {
          video.addEventListener('error', () => {
            if (video === (this.fullMode ? this.full : this.preview)) this.error.hidden = false;
          }, options);
        });
        document.addEventListener('visibilitychange', () => this.updatePreview(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            this.updatePreview();
          });
          this.observer.observe(this);
        } else {
          this.inView = true;
          this.updatePreview();
        }
      }

      updatePreview() {
        if (this.fullMode || this.userPaused || !this.inView || document.hidden || !this.source) {
          this.preview.pause();
          return;
        }
        if (!this.preview.getAttribute('src')) this.preview.src = this.source;
        this.preview.play().catch(() => {});
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.preview?.pause();
        this.full?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editable-home-12"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.swatches button');
  if (!swatch) return;

  var section = swatch.closest('[data-native-section="editable-home-12"]');
  if (!section) return;

  var color = swatch.getAttribute('aria-label');
  if (color !== 'Pearl White' && color !== 'Obsidian Black') return;

  section.querySelectorAll('[data-color-price]').forEach(function (price) {
    price.hidden = price.getAttribute('data-color-price') !==
      (color === 'Obsidian Black' ? 'black' : 'white');
  });
  tpUpdateHomeCheckout(section);
});

function tpUpdateHomeCheckout(section) {
  var link = section.querySelector('[data-home-checkout]');
  if (!link) return null;
  var selected = section.querySelector('.swatches button[aria-pressed="true"]');
  var black = selected && selected.getAttribute('aria-label') === 'Obsidian Black';
  var variantId = Number(link.getAttribute(black ? 'data-checkout-black' : 'data-checkout-white'));
  if (!Number.isSafeInteger(variantId) || variantId <= 0) return null;
  var cartPath = link.getAttribute('data-checkout-cart');
  if (!cartPath) return null;
  link.href = cartPath.replace(/\/$/, '') + '/' + variantId + ':1';
  return link;
}
function tpHomeCheckoutClick(event) {
  var link = event.target.closest('[data-home-checkout]');
  if (!link) return;
  var section = link.closest('[data-native-section="editable-home-12"]');
  if (!section) return;
  if (!tpUpdateHomeCheckout(section)) event.preventDefault();
}
document.addEventListener('click', tpHomeCheckoutClick, true);
document.addEventListener('auxclick', tpHomeCheckoutClick, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editable-product-01"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('melo-walkthrough-seek')) {
    customElements.define('melo-walkthrough-seek', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const frame = this.previousElementSibling;
        const video = frame?.querySelector('video[data-inline-walkthrough]');
        const button = frame?.querySelector('.cinema-open');
        if (!video || !button) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const range = this.querySelector('input');
        const time = this.querySelector('.walkthrough-seek__time');
        let dragging = false;
        const formatTime = seconds => {
          const total = Math.max(0, Math.floor(seconds || 0));
          return Math.floor(total / 60) + ':' + String(total % 60).padStart(2, '0');
        };
        const sync = () => {
          const ready = Number.isFinite(video.duration) && video.duration > 0;
          range.disabled = !ready;
          if (!ready) return;
          range.max = String(video.duration);
          if (!dragging) range.value = String(Math.min(video.currentTime, video.duration));
          const elapsed = formatTime(dragging ? Number(range.value) : video.currentTime);
          const total = formatTime(video.duration);
          time.textContent = elapsed + ' / ' + total;
          range.setAttribute('aria-valuetext', elapsed + ' / ' + total);
        };
        button.addEventListener('click', () => {
          this.hidden = false;
          sync();
        }, options);
        ['loadedmetadata', 'durationchange', 'timeupdate', 'seeked', 'ended', 'emptied'].forEach(event => video.addEventListener(event, sync, options));
        range.addEventListener('pointerdown', () => { dragging = true; }, options);
        range.addEventListener('input', () => {
          if (range.disabled) return;
          video.currentTime = Math.min(video.duration, Math.max(0, Number(range.value)));
          sync();
        }, options);
        const finish = () => {
          dragging = false;
          sync();
        };
        range.addEventListener('change', finish, options);
        window.addEventListener('pointerup', finish, options);
        window.addEventListener('pointercancel', finish, options);
        if (!video.loop && !video.muted) this.hidden = false;
        sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
